export default {
  image: 'A4_9_2.png',
  pdf: '220815_WA-MIWO_010_A4_9_2_Rev02_ar.pdf',
  productData: {
    serialNumber: 'WA-MIWO-010',
    technicalValues: {
      soundReductionIndex: {
        output: '58,3',
        value: 58.3
      },
      heatTransferCoefficient: {
        output: '0,13',
        value: 0.13
      },
      fireBehavior: {
        output: 'schwerentflammbar (B1)',
        value: 'B1'
      },
      fireResistanceOuter: {
        output: 'F 90-B',
        value: 'F-90-B'
      },
      fireResistanceInner: {
        output: 'F 60-B',
        value: 'F-60-B'
      }
    },
    name: 'Wandaufbau mit Mineralwolle l Aufbau 10',
    construction: {
      composition: [
        {
          output: 'mineralischer Unterputz',
          type: 'render',
          title: { de: 'Putz' },
          value: 'min-1'
        },
        {
          output: '100 mm Sto-Steinwolleplatte 2/B/H4 W5',
          type: 'pinsulation',
          title: { de: 'Dämmung' },
          value: 'mst-100'
        },
        {
          output: '12,5 mm Gipsfaserplatte',
          type: 'outerPlanking',
          title: { de: 'Beplankung Außen' },
          value: 'opg-12'
        },
        {
          output: '60/200',
          type: 'stand',
          title: { de: 'Ständer' },
          value: 'stae-200'
        },
        {
          output: '200 mm Glaswolle',
          type: 'compartmentInsulation',
          title: { de: 'Gefachdämmung' },
          value: 'cigw-200'
        },
        {
          output: '12,5 mm Gipsfaserplatte',
          type: 'innerPlanking1',
          title: { de: 'Beplankung Innen 1. Lage' },
          value: 'if-12'
        },
        {
          output: '12,5 mm Gipskartonplatte',
          type: 'innerPlanking2',
          title: { de: 'Beplankung Innen 2. Lage' },
          value: 'in-12'
        }, 
        {
          output: 'keine',
          type: 'innerPlanking3',
          title: { de: 'Beplankung Innen 3. Lage' },
          value: null
        }
      ],
      sum: {
        output: '346,5',
        value: 346.5
      }
    }
  }
}
